// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Redirect route from old customer location-assets URL to new company URL.
 * Maintains backward compatibility for bookmarks and external links.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/customers/$customerKey/location-assets'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/companies/$companyKey/location-assets',
      params: { companyKey: params.customerKey },
    });
  },
});
